import React, { PureComponent, Fragment } from "react";
import { Container, Col, Row, Button } from "bootstrap-4-react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Reaptcha from "reaptcha";
import * as apiUrl from "./../../apiUrl";
// import img from '../../assets/Marquis_Galleria_Assets-01.jpg';
import Logo from "./../../assets/Marquis_Galleria_Logo-01.svg";

const countryCodeMap = {
  IN: "+91", // India
  AF: "+93", // Afghanistan
  AL: "+355", // Albania
  DZ: "+213", // Algeria
  AS: "+1-684", // American Samoa
  AD: "+376", // Andorra
  AO: "+244", // Angola
  AI: "+1-264", // Anguilla
  AG: "+1-268", // Antigua and Barbuda
  AR: "+54", // Argentina
  AM: "+374", // Armenia
  AW: "+297", // Aruba
  AU: "+61", // Australia
  AT: "+43", // Austria
  AZ: "+994", // Azerbaijan
  BS: "+1-242", // Bahamas
  BH: "+973", // Bahrain
  BD: "+880", // Bangladesh
  BB: "+1-246", // Barbados
  BY: "+375", // Belarus
  BE: "+32", // Belgium
  BZ: "+501", // Belize
  BJ: "+229", // Benin
  BT: "+975", // Bhutan
  BO: "+591", // Bolivia
  BA: "+387", // Bosnia and Herzegovina
  BW: "+267", // Botswana
  BR: "+55", // Brazil
  IO: "+246", // British Indian Ocean Territory
  VG: "+1-284", // British Virgin Islands
  BN: "+673", // Brunei
  BG: "+359", // Bulgaria
  BF: "+226", // Burkina Faso
  BI: "+257", // Burundi
  KH: "+855", // Cambodia
  CM: "+237", // Cameroon
  CA: "+1", // Canada
  CV: "+238", // Cape Verde
  KY: "+1-345", // Cayman Islands
  CF: "+236", // Central African Republic
  TD: "+235", // Chad
  CL: "+56", // Chile
  CN: "+86", // China
  CX: "+61", // Christmas Island
  CC: "+61", // Cocos (Keeling) Islands
  CO: "+57", // Colombia
  KM: "+269", // Comoros
  CG: "+242", // Congo
  CD: "+243", // Congo, Democratic Republic of the
  CK: "+682", // Cook Islands
  CR: "+506", // Costa Rica
  CI: "+225", // Côte d'Ivoire
  HR: "+385", // Croatia
  CU: "+53", // Cuba
  CW: "+599", // Curaçao
  CY: "+357", // Cyprus
  CZ: "+420", // Czech Republic
  DK: "+45", // Denmark
  DJ: "+253", // Djibouti
  DM: "+1-767", // Dominica
  DO: "+1-809", // Dominican Republic
  EC: "+593", // Ecuador
  EG: "+20", // Egypt
  SV: "+503", // El Salvador
  GQ: "+240", // Equatorial Guinea
  ER: "+291", // Eritrea
  EE: "+372", // Estonia
  ET: "+251", // Ethiopia
  FK: "+500", // Falkland Islands
  FO: "+298", // Faroe Islands
  FJ: "+679", // Fiji
  FI: "+358", // Finland
  FR: "+33", // France
  GF: "+594", // French Guiana
  PF: "+689", // French Polynesia
  TF: "+262", // French Southern Territories
  GA: "+241", // Gabon
  GM: "+220", // Gambia
  GE: "+995", // Georgia
  DE: "+49", // Germany
  GH: "+233", // Ghana
  GI: "+350", // Gibraltar
  GR: "+30", // Greece
  GL: "+299", // Greenland
  GD: "+1-473", // Grenada
  GP: "+590", // Guadeloupe
  GU: "+1-671", // Guam
  GT: "+502", // Guatemala
  GG: "+44-1481", // Guernsey
  GN: "+224", // Guinea
  GW: "+245", // Guinea-Bissau
  GY: "+592", // Guyana
  HT: "+509", // Haiti
  HM: "+672", // Heard Island and McDonald Islands
  VA: "+379", // Holy See
  HN: "+504", // Honduras
  HK: "+852", // Hong Kong
  HU: "+36", // Hungary
  IS: "+354", // Iceland
  ID: "+62", // Indonesia
  IR: "+98", // Iran
  IQ: "+964", // Iraq
  IE: "+353", // Ireland
  IM: "+44-1624", // Isle of Man
  IL: "+972", // Israel
  IT: "+39", // Italy
  JE: "+44-1534", // Jersey
  JO: "+962", // Jordan
  KZ: "+7", // Kazakhstan
  KE: "+254", // Kenya
  KI: "+686", // Kiribati
  KP: "+850", // Korea, North
  KR: "+82", // Korea, South
  KW: "+965", // Kuwait
  KG: "+996", // Kyrgyzstan
  LA: "+856", // Laos
  LV: "+371", // Latvia
  LB: "+961", // Lebanon
  LS: "+266", // Lesotho
  LR: "+231", // Liberia
  LY: "+218", // Libya
  LI: "+423", // Liechtenstein
  LT: "+370", // Lithuania
  LU: "+352", // Luxembourg
  MO: "+853", // Macao
  MK: "+389", // Macedonia
  MG: "+261", // Madagascar
  MW: "+265", // Malawi
  MY: "+60", // Malaysia
  MV: "+960", // Maldives
  ML: "+223", // Mali
  MT: "+356", // Malta
  MH: "+692", // Marshall Islands
  MQ: "+596", // Martinique
  MR: "+222", // Mauritania
  MU: "+230", // Mauritius
  YT: "+262", // Mayotte
  MX: "+52", // Mexico
  FM: "+691", // Micronesia
  MD: "+373", // Moldova
  MC: "+377", // Monaco
  MN: "+976", // Mongolia
  MS: "+1-664", // Montserrat
  MA: "+212", // Morocco
  MZ: "+258", // Mozambique
  MM: "+95", // Myanmar
  NA: "+264", // Namibia
  NR: "+674", // Nauru
  NP: "+977", // Nepal
  NL: "+31", // Netherlands
  NC: "+687", // New Caledonia
  NZ: "+64", // New Zealand
  NI: "+505", // Nicaragua
  NE: "+227", // Niger
  NG: "+234", // Nigeria
  NU: "+683", // Niue
  NF: "+672", // Norfolk Island
  MP: "+1-670", // Northern Mariana Islands
  NO: "+47", // Norway
  OM: "+968", // Oman
  PK: "+92", // Pakistan
  PW: "+680", // Palau
  PA: "+507", // Panama
  PG: "+675", // Papua New Guinea
  PY: "+595", // Paraguay
  PE: "+51", // Peru
  PH: "+63", // Philippines
  PN: "+870", // Pitcairn Islands
  PL: "+48", // Poland
  PT: "+351", // Portugal
  PR: "+1-787", // Puerto Rico
  QA: "+974", // Qatar
  RE: "+262", // Réunion
  RO: "+40", // Romania
  RU: "+7", // Russia
  RW: "+250", // Rwanda
  BL: "+590", // Saint Barthélemy
  SH: "+290", // Saint Helena
  KN: "+1-869", // Saint Kitts and Nevis
  LC: "+1-758", // Saint Lucia
  MF: "+590", // Saint Martin
  VC: "+1-784", // Saint Vincent and the Grenadines
  WS: "+685", // Samoa
  SM: "+378", // San Marino
  ST: "+239", // São Tomé and Príncipe
  SA: "+966", // Saudi Arabia
  SN: "+221", // Senegal
  RS: "+381", // Serbia
  SC: "+248", // Seychelles
  SL: "+232", // Sierra Leone
  SG: "+65", // Singapore
  SX: "+1-721", // Sint Maarten
  SK: "+421", // Slovakia
  SI: "+386", // Slovenia
  SB: "+677", // Solomon Islands
  SO: "+252", // Somalia
  ZA: "+27", // South Africa
  GS: "+500", // South Georgia and the South Sandwich Islands
  SS: "+211", // South Sudan
  ES: "+34", // Spain
  LK: "+94", // Sri Lanka
  SD: "+249", // Sudan
  SR: "+597", // Suriname
  SZ: "+268", // Swaziland
  SE: "+46", // Sweden
  CH: "+41", // Switzerland
  SY: "+963", // Syria
  TW: "+886", // Taiwan
  TJ: "+992", // Tajikistan
  TZ: "+255", // Tanzania
  TH: "+66", // Thailand
  TL: "+670", // Timor-Leste
  TG: "+228", // Togo
  TK: "+690", // Tokelau
  TO: "+676", // Tonga
  TT: "+1-868", // Trinidad and Tobago
  TN: "+216", // Tunisia
  TR: "+90", // Turkey
  TM: "+993", // Turkmenistan
  TC: "+1-649", // Turks and Caicos Islands
  TV: "+688", // Tuvalu
  UG: "+256", // Uganda
  UA: "+380", // Ukraine
  AE: "+971", // United Arab Emirates
  GB: "+44", // United Kingdom
  US: "+1", // United States
  UY: "+598", // Uruguay
  UZ: "+998", // Uzbekistan
  VU: "+678", // Vanuatu
  VE: "+58", // Venezuela
  VN: "+84", // Vietnam
  VG: "+1-284", // Virgin Islands (British)
  VI: "+1-340", // Virgin Islands (US)
  WF: "+681", // Wallis and Futuna
  EH: "+212", // Western Sahara
  YE: "+967", // Yemen
  ZM: "+260", // Zambia
  ZW: "+263", // Zimbabwe
};
const SLOT_CONFIG = [
  {
    value: "2026-04-27",
    label: "Monday, April 27",
    slots: [
      "10:00 AM – 11:00 AM",
      "12:00 PM – 1:00 PM",
      "2:00 PM – 3:00 PM",
      "4:00 PM – 5:00 PM",
    ],
  },
  {
    value: "2026-04-28",
    label: "Tuesday, April 28",
    slots: [
      "10:00 AM – 11:00 AM",
      "12:00 PM – 1:00 PM",
      "2:00 PM – 3:00 PM",
      "4:00 PM – 5:00 PM",
    ],
  },
  {
    value: "2026-04-29",
    label: "Wednesday, April 29",
    slots: [
      "10:00 AM – 11:00 AM",
      "12:00 PM – 1:00 PM",
      "2:00 PM – 3:00 PM",
      "4:00 PM – 5:00 PM",
    ],
  },
  {
    value: "2026-04-30",
    label: "Thursday, April 30",
    slots: [
      "10:00 AM – 11:00 AM",
      "12:00 PM – 1:00 PM",
      "2:00 PM – 3:00 PM",
      "4:00 PM – 5:00 PM",
    ],
  },
  {
    value: "2026-05-01",
    label: "Friday, May 01",
    slots: [
      "10:00 AM – 11:00 AM",
      "1:00 PM – 2:00 PM",
      "3:00 PM – 4:00 PM",
      "5:00 PM – 6:00 PM",
    ],
  },
];

class HomeBanner extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      // form fields
      name: "",
      agencyName: "",
      phone: "",
      countryCode: "+971",
      email: "",
      totalAttendees: "",
      selectedDay: "",
      selectedSlot: "",
      errors: {},
      checkbox: false,

      // slot availability from API
      slotAvailability: {},
      loadingSlots: false,

      // captcha
      captchaToken: null,

      // modals & status
      ThankYou: false,
      submitting: false,
      serverError: null, // ← general backend error message
    };

    this.validate = this.validate.bind(this);
    this.onlyAlphabets = this.onlyAlphabets.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onCaptchaVerify = this.onCaptchaVerify.bind(this);
    this.ThankYouModalclose = this.ThankYouModalclose.bind(this);
  }

  componentDidMount() {
    this.fetchSlotAvailability();
  }

  // ─── API ─────────────────────────────────────────────────────────────────────

  fetchSlotAvailability() {
    this.setState({ loadingSlots: true });
    axios
      .get(apiUrl.apiUrl + "/slots")
      .then((res) => {
        const map = {};
        (res.data.data || []).forEach((s) => {
          map[s.slot_id] = {
            available: s.available,
            spots_remaining: s.spots_remaining,
            attendee_count: s.attendee_count,
          };
        });
        this.setState({ slotAvailability: map, loadingSlots: false });
      })
      .catch(() => {
        this.setState({ loadingSlots: false });
      });
  }

  getSlotId(date, timeLabel) {
    const timeMap = {
      "10:00 AM – 11:00 AM": "10:00-11:00",
      "12:00 PM – 1:00 PM": "12:00-13:00",
      "2:00 PM – 3:00 PM": "14:00-15:00",
      "4:00 PM – 5:00 PM": "16:00-17:00",
      "1:00 PM – 2:00 PM": "13:00-14:00",
      "3:00 PM – 4:00 PM": "15:00-16:00",
      "5:00 PM – 6:00 PM": "17:00-18:00",
    };
    return `${date}_${timeMap[timeLabel] || timeLabel}`;
  }

  // ─── Field Handlers ───────────────────────────────────────────────────────────

  setField = (field) => (event) => {
    this.setState({
      [field]: event.target.value,
      errors: { ...this.state.errors, [field]: "" },
      serverError: null,
    });
  };

  handleDayChange = (event) => {
    this.setState({
      selectedDay: event.target.value,
      selectedSlot: "",
      errors: { ...this.state.errors, selectedDay: "", selectedSlot: "" },
      serverError: null,
    });
  };

  handleSlotSelect = (slot) => {
    const slotId = this.getSlotId(this.state.selectedDay, slot);
    const info = this.state.slotAvailability[slotId];
    if (info && !info.available) return;
    this.setState({
      selectedSlot: slot,
      errors: { ...this.state.errors, selectedSlot: "" },
      serverError: null,
    });
  };

  Setcheckbox = (event) => {
    this.setState({
      checkbox: event.target.checked,
      errors: { ...this.state.errors, checkbox: "" },
    });
  };

  onCaptchaVerify = (token) => {
    this.setState({
      captchaToken: token,
      errors: { ...this.state.errors, captcha: "" },
    });
  };

  validate(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  onlyAlphabets(evt) {
    try {
      var charCode = evt ? evt.which : window.event.keyCode;
      if (
        (charCode > 64 && charCode < 91) ||
        (charCode > 96 && charCode < 123) ||
        charCode === 32
      )
        return true;
      else evt.preventDefault();
    } catch (err) {}
  }

  // ─── Validation ───────────────────────────────────────────────────────────────

  validateForm() {
    const {
      name,
      agencyName,
      phone,
      countryCode,
      email,
      totalAttendees,
      selectedDay,
      selectedSlot,
      captchaToken,
    } = this.state;
    const errors = {};
    let formIsValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!name) {
      errors["name"] = "Please enter your name";
      formIsValid = false;
    }
    if (!agencyName) {
      errors["agencyName"] = "Please enter your agency name";
      formIsValid = false;
    }
    if (!countryCode) {
      errors["countryCode"] = "Please choose country code";
      formIsValid = false;
    }
    if (!phone) {
      errors["phone"] = "Please enter your mobile number";
      formIsValid = false;
    } else if (!/^\d{5,12}$/.test(phone)) {
      errors["phone"] =
        "Please enter a valid phone number (digits only, no spaces)";
      formIsValid = false;
    }

    if (!email) {
      errors["email"] = "Please enter your email address";
      formIsValid = false;
    } else if (!emailRegex.test(email)) {
      errors["email"] = "Please enter a valid email address";
      formIsValid = false;
    }
    if (!totalAttendees || parseInt(totalAttendees) < 1) {
      errors["totalAttendees"] = "Please enter number of attendees";
      formIsValid = false;
    }
    if (!selectedDay) {
      errors["selectedDay"] = "Please select a day";
      formIsValid = false;
    }
    if (!selectedSlot) {
      errors["selectedSlot"] = "Please select a time slot";
      formIsValid = false;
    }
    if (!captchaToken) {
      errors["captcha"] = "*Please complete the captcha";
      formIsValid = false;
    }

    this.setState({ errors, serverError: null });
    return formIsValid;
  }

  // ─── Submit ───────────────────────────────────────────────────────────────────

  async handleSubmit() {
    if (!this.validateForm()) return;

    const {
      name,
      agencyName,
      phone,
      email,
      totalAttendees,
      selectedDay,
      selectedSlot,
      captchaToken,
    } = this.state;

    const slotId = this.getSlotId(selectedDay, selectedSlot);
    const dayConfig = SLOT_CONFIG.find((d) => d.value === selectedDay);

    this.setState({ submitting: true, serverError: null });

    try {
      const res = await axios.post(apiUrl.apiUrl + "/bookings", {
        slot_id: slotId,
        name,
        agency_name: agencyName,
        phone: `${this.state.countryCode}${phone}`,
        email,
        total_attendees: parseInt(totalAttendees),
        contact_details: `${email} | ${phone}`,
        day_label: dayConfig?.label || selectedDay,
        time_label: selectedSlot,
        captchaToken: captchaToken,
      });

      if (res.data.success) {
        this.setState({
          ThankYou: true,
          name: "",
          agencyName: "",
          phone: "",
          countryCode: "+971",
          email: "",
          totalAttendees: "",
          selectedDay: "",
          selectedSlot: "",
          checkbox: false,
          captchaToken: null,
          errors: {},
          serverError: null,
        });
        if (this.captchaRef) this.captchaRef.reset();
        this.fetchSlotAvailability();
      } else {
        // success: false from backend (e.g. slot just became full)
        this.setState({
          serverError:
            res.data.message || "Something went wrong. Please try again.",
        });
        if (this.captchaRef) this.captchaRef.reset();
        this.setState({ captchaToken: null });
      }
    } catch (error) {
      const responseData = error.response?.data;

      if (error.response?.status === 422 && responseData?.errors) {
        // Laravel validation errors — map back to form fields
        const fieldMap = {
          slot_id: "selectedSlot",
          name: "name",
          agency_name: "agencyName",
          phone: "phone",
          email: "email",
          total_attendees: "totalAttendees",
        };
        const fieldErrors = {};
        Object.entries(responseData.errors).forEach(([key, messages]) => {
          const fieldKey = fieldMap[key] || key;
          fieldErrors[fieldKey] = Array.isArray(messages)
            ? messages[0]
            : messages;
        });
        this.setState({ errors: fieldErrors });
      } else {
        // Any other backend error or network failure — show in banner
        const msg =
          responseData?.message || "Something went wrong. Please try again.";
        this.setState({ serverError: msg });
      }

      if (this.captchaRef) this.captchaRef.reset();
      this.setState({ captchaToken: null });
    } finally {
      this.setState({ submitting: false });
    }
  }

  ThankYouModalclose() {
    this.setState({ ThankYou: false });
  }

  // ─── Render Helpers ───────────────────────────────────────────────────────────

  renderSlotButtons() {
    const { selectedDay, selectedSlot, slotAvailability, loadingSlots } =
      this.state;
    if (!selectedDay) return null;

    const dayConfig = SLOT_CONFIG.find((d) => d.value === selectedDay);
    if (!dayConfig) return null;

    if (loadingSlots) {
      return <p className="slot-loading-text">Loading slots...</p>;
    }

    return (
      <div className="slots-wrapper">
        {dayConfig.slots.map((slot) => {
          const slotId = this.getSlotId(selectedDay, slot);
          const info = slotAvailability[slotId];
          const isFull = info && !info.available;
          const isSelected = selectedSlot === slot;

          return (
            <button
              key={slot}
              type="button"
              disabled={isFull}
              onClick={() => this.handleSlotSelect(slot)}
              className={[
                "slot-btn",
                isFull ? "slot-btn--full" : "slot-btn--open",
                isSelected ? "slot-btn--selected" : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <span className="slot-btn-time">{slot}</span>
              {isFull ? (
                <span className="slot-btn-status slot-btn-status--full">
                  Full
                </span>
              ) : (
                <span className="slot-btn-status slot-btn-status--open">
                  {info ? `${info.spots_remaining} spots left` : "Available"}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  render() {
    const {
      name,
      agencyName,
      phone,
      email,
      totalAttendees,
      selectedDay,
      errors,
      submitting,
      serverError,
    } = this.state;

    return (
      <Fragment>
        <section className="banner-sec tour-banner-sec" id="banner-sec">
          <div className="overlay"></div>
          <div className="form-div">
            <Container fluid className="form-div-container">
              <Row className="form-div-row">
                {/* ── Left: Event Info ── */}
                <Col md={6}>
                  <div className="form-div-content tour-right-content">
                    {/* <img src={Logo} className="img-fluid"/> */}
                    <h4 className="mondiaBold">Exclusive Property Tour</h4>
                    <p className="tour-info-value goldenColorBG">        
                      Monday, April 27th till Friday, May 01 - 2026
                    </p>
                    <p className="tour-info-value">
                      Venue - Marquis Galleria <br />
                      Basement parking available
                    </p>
                    {/* <div className="tour-info-blocks">
                      <div className="tour-info-item">
                        <div>
                          <p className="tour-info-label">Event Dates</p>
                          <p className="tour-info-value">Monday, April 20th till Friday, April 24</p>
                        </div>
                      </div>
                      <div className="tour-info-item">
                        <div>
                          <p className="tour-info-label">Venue</p>
                          <p className="tour-info-value">Marquis Galleria</p>
                        </div>
                      </div>
                      <div className="tour-info-item">
                        <div>
                          <p className="tour-info-label">Mon – Thu Slots</p>
                          <p className="tour-info-value">10–11 AM &nbsp;·&nbsp; 12–1 PM &nbsp;·&nbsp; 2–3 PM &nbsp;·&nbsp; 4–5 PM</p>
                        </div>
                      </div>
                      <div className="tour-info-item">
                        <div>
                          <p className="tour-info-label">Friday Slots</p>
                          <p className="tour-info-value">10–11 AM &nbsp;·&nbsp; 1–2 PM &nbsp;·&nbsp; 3–4 PM &nbsp;·&nbsp; 5–6 PM</p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </Col>

                {/* ── Right: RSVP Form ── */}
                <Col md={6} className="flex-center">
                  <div className="banner-form-div">
                    <div className="tour-form-heading">
                      <h4 className="mondiaBold">RSVP Form</h4>
                    </div>

                    <div className="contact-form-div">
                      {/* ── Server Error Banner ── */}
                      {serverError && (
                        <div className="server-error-banner">
                          <span className="server-error-icon">⚠</span>
                          {serverError}
                        </div>
                      )}

                      <Form>
                        {/* Name */}
                        <Form.Group className="form-div">
                          <Form.Control
                            type="text"
                            placeholder="Your Name *"
                            value={name}
                            onChange={this.setField("name")}
                            onKeyPress={this.onlyAlphabets}
                          />
                          <span className="form-error">{errors["name"]}</span>
                        </Form.Group>

                        {/* Agency */}
                        <Form.Group className="form-div">
                          <Form.Control
                            type="text"
                            placeholder="Agency Name *"
                            value={agencyName}
                            onChange={this.setField("agencyName")}
                          />
                          <span className="form-error">
                            {errors["agencyName"]}
                          </span>
                        </Form.Group>

                        {/* Phone */}
                        {/* Phone */}
                        <Form.Group className="form-div">
                          <div className="phone-input-wrapper">
                            <Form.Select
                              className="custom-form-control select"
                              value={this.state.countryCode}
                              onChange={(e) =>
                                this.setState({
                                  countryCode: e.target.value,
                                  errors: {
                                    ...this.state.errors,
                                    countryCode: "",
                                  },
                                })
                              }
                            >
                              <option value="">Select Country Code *</option>
                              {Object.entries(countryCodeMap).map(
                                ([code, dialCode]) => (
                                  <option key={code} value={dialCode}>
                                    {`${code} (${dialCode})`}
                                  </option>
                                ),
                              )}
                            </Form.Select>
                            <Form.Control
                              type="text"
                              placeholder="Phone Number *"
                              value={phone}
                              onChange={this.setField("phone")}
                              onKeyPress={this.validate}
                              className="phone-number-input"
                            />
                          </div>
                          <div style={{ display: "flex" }}>
                            {errors["countryCode"] && (
                              <span className="form-error">
                                {errors["countryCode"]}
                              </span>
                            )}
                            {errors["phone"] && (
                              <span className="form-error">
                                {errors["phone"]}
                              </span>
                            )}
                          </div>
                        </Form.Group>

                        {/* Email */}
                        <Form.Group className="form-div">
                          <Form.Control
                            type="text"
                            placeholder="Email *"
                            value={email}
                            onChange={this.setField("email")}
                          />
                          <span className="form-error">{errors["email"]}</span>
                        </Form.Group>

                        {/* Total Attendees */}
                        <Form.Group className="form-div">
                          <Form.Control
                            type="number"
                            placeholder="Total Attendees *"
                            value={totalAttendees}
                            min={1}
                            max={25}
                            onChange={this.setField("totalAttendees")}
                            onKeyPress={this.validate}
                          />
                          <span className="form-error">
                            {errors["totalAttendees"]}
                          </span>
                        </Form.Group>

                        {/* Day Dropdown */}
                        <Form.Group className="form-div">
                          <Form.Control
                            as="select"
                            value={selectedDay}
                            onChange={this.handleDayChange}
                            className="tour-day-select"
                          >
                            <option value="">Select a Day *</option>
                            {SLOT_CONFIG.map((d) => (
                              <option key={d.value} value={d.value}>
                                {d.label}
                              </option>
                            ))}
                          </Form.Control>
                          <span className="form-error">
                            {errors["selectedDay"]}
                          </span>
                        </Form.Group>

                        {/* Slot Buttons */}
                        {selectedDay && (
                          <Form.Group className="form-div">
                            <label className="slot-select-label">
                              Select a Time Slot *
                            </label>
                            {this.renderSlotButtons()}
                            <span className="form-error">
                              {errors["selectedSlot"]}
                            </span>
                          </Form.Group>
                        )}

                        {/* Captcha */}
                        <Form.Group>
                          <Reaptcha
                            sitekey="6LeTGIUjAAAAAOvE0c8UArczATZOmeKGZrVFAg_C"
                            onVerify={this.onCaptchaVerify}
                            ref={(e) => (this.captchaRef = e)}
                          />
                          <span className="form-error">
                            {errors["captcha"]}
                          </span>
                        </Form.Group>

                        {/* Submit */}
                        <div className="contact-send-btn-div">
                          <Button
                            className="goldernColorBtn"
                            type="button"
                            onClick={this.handleSubmit}
                            disabled={submitting}
                          >
                            {submitting ? "Submitting..." : "Register Now"}
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>

        {/* ── Thank You Modal ── */}
        <Modal
          show={this.state.ThankYou}
          onHide={this.ThankYouModalclose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="page-load-modal"
        >
          <Modal.Header
            className="page-load-modal-header"
            closeButton
          ></Modal.Header>
          <Modal.Body className="page-load-modal">
            <div className="container first-modal-container">
              <div className="row first-modal-row">
                <div className="col-md-10">
                  <div className="first-modal-content">
                    <div className="first-modal-heading">
                      <h5 id="ThankYouMessage">Booking Confirmed!</h5>
                      <p>
                        Thank you for registering for the Exclusive Property
                        Tour. We'll see you there!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

export default HomeBanner;
